export const DP_ROUTE_SOURCE = {
  ORDER_SUMMARY: 'ORDER_SUMMARY',
  DP_DETAILS: 'DP_DETAILS',
};